import { render, staticRenderFns } from "./ratingList.vue?vue&type=template&id=5c46ba7c&scoped=true"
import script from "./ratingList.vue?vue&type=script&lang=js"
export * from "./ratingList.vue?vue&type=script&lang=js"
import style0 from "./ratingList.vue?vue&type=style&index=0&id=5c46ba7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c46ba7c",
  null
  
)

export default component.exports